import { rootReducer } from "./root/rootReducer";
import { createStore, combineReducers } from "redux";

const rootCombineReducer = combineReducers({
  root: rootReducer,
});

export const store = createStore(rootCombineReducer);
